import axiosInstance from './axiosInstance'
import { OFIMA_PEDIDOS_PATH, ofimaPedidoByOrdenPath } from '../constants/ofimaPedidosApiPaths'
import type {
  OfimaPedidoDetalle,
  OfimaPedidoDetailResponse,
  OfimaPedidoListItem,
  OfimaPedidosListResponse,
  OfimaPedidosPagination,
  OfimaPedidosQuery
} from '../types/ofimaPedidos'
import { buildOfimaPedidosQuery, normalizeOfimaTipoDcto } from '../utils/ofimaPedidos'

export interface OfimaPedidosListResult {
  success?: boolean
  message?: string
  data: OfimaPedidoListItem[]
  pagination?: OfimaPedidosPagination
}

export const ofimaPedidosService = {
  async getPedidos(query: OfimaPedidosQuery = {}): Promise<OfimaPedidosListResult> {
    const params = buildOfimaPedidosQuery(query)
    const response = await axiosInstance.get<OfimaPedidosListResponse>(OFIMA_PEDIDOS_PATH, {
      params
    })
    return {
      ...response.data,
      data: Array.isArray(response.data?.data) ? response.data.data : []
    }
  },

  async getPedidoByOrden(orden: string, tipodcto?: string): Promise<OfimaPedidoDetalle> {
    const value = orden.trim()
    if (!value) {
      throw new Error('Indica el pedido a consultar')
    }
    const tipo = normalizeOfimaTipoDcto(tipodcto)
    const response = await axiosInstance.get<OfimaPedidoDetailResponse>(
      ofimaPedidoByOrdenPath(value),
      tipo ? { params: { tipodcto: tipo } } : undefined
    )
    if (!response.data?.data) {
      throw new Error('No fue posible consultar el pedido')
    }
    return response.data.data
  }
}

export default ofimaPedidosService
